var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-wrapper"},[_c('div',{staticClass:"line-number"},[_vm._v(_vm._s(_vm.source.offset))]),_c('div',{staticClass:"line-content"},[_vm._v(_vm._s(_vm.source.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }